<form [formGroup]="propietarioForm" *appRole="['Propietarios.Ver']">
    <div class="row">
        <div class="form-group col-md-3">
            <mat-form-field class="example-full-width">
                <span matPrefix>%&nbsp;</span>
                <mat-label>Comision</mat-label>
                <input matInput name="Comision" cdkFocusInitial appPercentageDirective min="1" max="100" [(ngModel)]="comision" type="text" formControlName="Comision" />
                <mat-error *ngIf="f.Comision.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
            </mat-form-field>
        </div>
        <div class="form-group col-md-3">
            <mat-form-field>
                <ngx-spinner name="spTipoLiquidacion" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Tipo Liquidación</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="TipoLiquidacion" (selectionChange)="selectTipoLiquidacion($event)">
                    <mat-option [value]="tipoLiquidacion.id" *ngFor="let tipoLiquidacion of lstTipoLiquidacionModel ;let i=index;trackBy:trackByItems">
                        {{tipoLiquidacion.descripcion}}</mat-option>
                </mat-select>

                <mat-error *ngIf="f.TipoLiquidacion.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
            </mat-form-field>
        </div>

        <div class="form-group col-md-3">
            <mat-form-field class="example-full-width">
                <mat-label>CUIT/CUIL</mat-label>
                <input matInput name="CuitCuil" type="text" formControlName="CuitCuil" [mask]="'00-00000000-0'" placeholder="00-00000000-0" />
                <mat-error *ngIf="f.CuitCuil.errors?.pattern">Formato invalido.</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="col-auto my-1">
        <div *appRole="['Propietarios.Crear']">
            <button mat-raised-button color="primary" style="margin-right:3px;" *ngIf="!esPropietarioNuevo" value="Agregar" [disabled]="!propietarioForm.valid " (click)="onSubmit()">Agregar</button>
        </div>
    </div>
</form>